export const push = data => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }
  window.dataLayer.push({
    event: 'autoEvent',
    eventLabel: '',
    eventValue: '',
    ...data
  });
};

export const pushVariables = data => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }
  window.dataLayer.push(data);
};



// WEBPACK FOOTER //
// ./src/utils/gtmDataLayer.js